import React, { useCallback, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import {
    getIdlePromptOpen,
} from '@atredux/selectors/atAlertSelector'

import Button from '@amzn/meridian/button'
import Column from '@amzn/meridian/column'
import Modal, { ModalFooter } from '@amzn/meridian/modal'
import Row from '@amzn/meridian/row'
import Text from '@amzn/meridian/text'
import { useBundle } from '@amzn/react-arb-tools'

import { BUNDLE_NAME } from '@src/constants'
import { t } from '@src/translationHelper'
import { MasterIndirectTaskService } from '@amzn/ihm-associate-tools-js-lib'
import { resetIdlePrompt, resetMI, setMI } from '@src/redux/slices/atAlertSlice'
import { _navigateToTool } from '@components/SideBar/utils/SideBarUtil'
import { IdleTimeService, TIME_OFF_TASK } from '@services/IdleTimeService'

const IdlePrompt = (): React.ReactElement => {
    const dispatch = useDispatch()
    const [bundle] = useBundle(BUNDLE_NAME)
    const open: boolean = useSelector(getIdlePromptOpen)
    let miConfig = MasterIndirectTaskService.getInstance().getConfig()

    // update config with the latest version on every render
    useEffect(() => {
        miConfig = MasterIndirectTaskService.getInstance().getConfig()
    }, [])

    const no = useCallback(() => {
        MasterIndirectTaskService.getInstance().setToT()
        dispatch(resetIdlePrompt())
        dispatch(setMI())
    }, [dispatch])

    const yes = useCallback(() => {
        const currentTask = MasterIndirectTaskService.getInstance().getMITask()
        MasterIndirectTaskService.getInstance().setMITask(currentTask)

        // Re-initialize idle prompts upon selection
        const promptThreshold = miConfig.MasterIndirectTasksList.tasks[currentTask]?.idlePromptThreshold
        const totThreshold = miConfig.MasterIndirectTasksList.tasks[currentTask]?.timeOffThreshold
        IdleTimeService.getInstance().init(promptThreshold, totThreshold)

        // If enough time has passed that time-off occured within this modal
        if (MasterIndirectTaskService.getInstance().getMITask() === TIME_OFF_TASK) {
            dispatch(setMI())
        }
        dispatch(resetIdlePrompt())
    }, [dispatch, miConfig])

    return (
        <Modal
            title={t(bundle, 'jsma-web-idle-title')}
            open={open}
            onClose={yes}
            scrollContainer="viewport"
            closeLabel={t(bundle, 'jsma-web-common-close')}
            width="75vw"
        >
            <Column alignmentVertical={'center'}>
                <Row alignmentHorizontal={'center'} alignmentVertical={'center'}>
                    <Text>{t(bundle, 'jsma-web-idle-message', { task: MasterIndirectTaskService.getInstance().getMITask() })}</Text>
                </Row>
            </Column>
            <ModalFooter>
                <Row alignmentHorizontal="end" widths="fit">
                    <Button type="secondary" size="small" onClick={no}>
                        {t(bundle, 'migrated-ihm-seaward-zone-timeout-no-button')}
                    </Button>
                    <Button type="primary" size="small" onClick={yes}>
                        {t(bundle, 'migrated-ihm-seaward-zone-timeout-yes-button')}
                    </Button>
                </Row>
            </ModalFooter>
        </Modal>
    )
}

export default IdlePrompt
